import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "tips",
  style: {
    "margin-bottom": "10px"
  }
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getSupplierTreeInfo, getSupplierTreeInfoByScienceId } from '@/request';
export default {
  name: 'supplier-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Array,
      default: () => []
    },
    taskType: [String, Number],
    scienceId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const treeData = ref([]);
    const treeRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });

    function treeCheck(data, node) {
      // let checkedNodes = treeRef.value.getCheckedNodes()
      // let targetNodes = checkedNodes.filter(item => item.supplierId == data.supplierId)
      treeRef.value.setCheckedKeys([]);
      treeRef.value.setCheckedNodes([data]);
    }

    function confirm() {
      visible.value = false;
      emit('success', treeRef.value.getCheckedNodes());
    }

    const treeProps = ref({
      label: 'text',
      children: 'children'
    });
    watch(() => props.modelValue, v => {
      if (v) getList();
    });

    function getList() {
      if (props.taskType == 3) {
        getSupplierTreeInfoByScienceId({
          scienceId: props.scienceId
        }).then(data => {
          if (data !== null && data !== void 0 && data.length) {
            treeData.value = data;

            if (data.length === 1) {
              // treeRef.value.setCheckedNodes([data[0]])
              let target = data[0];
              let defaultCheckedList = [target];

              if (target.children.length && target.children.length > 0) {
                target.children.forEach(subItem => {
                  defaultCheckedList.push(subItem);

                  if (subItem.children && subItem.children.length) {
                    subItem.children.forEach(lastItem => {
                      defaultCheckedList.push(lastItem);
                    });
                  }
                });
              }

              emit('success', defaultCheckedList, data.length);
            }
          }
        });
      } else {
        getSupplierTreeInfo().then(data => {
          if (data !== null && data !== void 0 && data.length) {
            treeData.value = data;

            if (data.length === 1) {
              // treeRef.value.setCheckedNodes([data[0]])
              let target = data[0];
              let defaultCheckedList = [target];

              if (target.children.length && target.children.length > 0) {
                target.children.forEach(subItem => {
                  defaultCheckedList.push(subItem);

                  if (subItem.children && subItem.children.length) {
                    subItem.children.forEach(lastItem => {
                      defaultCheckedList.push(lastItem);
                    });
                  }
                });
              }

              emit('success', defaultCheckedList, data.length);
            }
          }
        });
      }
    }

    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择团队",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [__props.taskType == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_1, "可选团队为参与所选会议的团队")) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
          height: "500px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            "default-checked-keys": __props.defaultChecked,
            data: treeData.value,
            "node-key": "id",
            ref_key: "treeRef",
            ref: treeRef,
            props: treeProps.value,
            "show-checkbox": "",
            accordion: "",
            onCheck: treeCheck
          }, null, 8, ["default-checked-keys", "data", "props"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};